function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["className", "disabled", "onChange", "style", "value", "type", "onKeyDown"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Clear, Search } from '@procore/core-icons/dist';
import React from 'react';
import { Button } from '../Button/Button';
import { useLayoutEventListener } from '../_hooks/EventListener';
import { mergeRefs } from '../_utils/mergeRefs';
import { StyledIcon, StyledInput, StyledTypeahead } from './Typeahead.styles';
/**
 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-typeahead--demo)

 */
export var Typeahead = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    onChange_ = _ref.onChange,
    style = _ref.style,
    value = _ref.value,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'search' : _ref$type,
    onKeyDown_ = _ref.onKeyDown,
    props = _objectWithoutProperties(_ref, _excluded);
  var onChange = React.useCallback(function onChange(e) {
    onChange_ === null || onChange_ === void 0 ? void 0 : onChange_(e.target.value, e);
  }, [onChange_]);
  var innerRef = React.useRef(null);
  useLayoutEventListener({
    dependencies: [onChange_, onKeyDown_],
    event: 'keydown',
    handler: function onKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        // stop propagation once to clear input
        if (e.target.value) {
          e.stopPropagation();
        }
        onChange_ === null || onChange_ === void 0 ? void 0 : onChange_('', _objectSpread(_objectSpread({}, e), {}, {
          target: _objectSpread(_objectSpread({}, e.target), {}, {
            value: ''
          })
        }));
      }
      onKeyDown_ === null || onKeyDown_ === void 0 ? void 0 : onKeyDown_(e);
    },
    scope: innerRef
  });
  var onClickClear = React.useCallback(function onClickClear(e) {
    if (!disabled) {
      onChange_ === null || onChange_ === void 0 ? void 0 : onChange_('', _objectSpread(_objectSpread({}, e), {}, {
        target: _objectSpread(_objectSpread({}, e.target), {}, {
          value: ''
        })
      }));
    }
  }, [disabled, onChange_]);
  return /*#__PURE__*/React.createElement(StyledTypeahead, {
    className: className,
    style: style,
    "data-qa": props['data-qa']
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({}, props, {
    type: type,
    "data-qa": "core-typeahead-input",
    ref: mergeRefs(innerRef, ref),
    onChange: onChange,
    disabled: disabled,
    value: value
  })), /*#__PURE__*/React.createElement(StyledIcon, {
    disabled: disabled
  }, value ? /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Clear the input",
    "data-qa": "core-typeahead-clear-icon",
    size: "sm",
    variant: "tertiary",
    icon: /*#__PURE__*/React.createElement(Clear, null),
    disabled: disabled,
    onClick: onClickClear,
    tabIndex: -1 // TODO revisit this accessibility
  }) : /*#__PURE__*/React.createElement(Search, {
    "data-qa": "core-typeahead-search-icon",
    size: "sm"
  })));
});
//# sourceMappingURL=Typeahead.js.map